import { AuthPage } from "@pages/auth/auth_page";
import { LoginPage } from "@pages/auth/login_page";
import { BasePage } from "@pages/base_page";
import { FinancePage } from "@pages/finance/finance_page";
import { PocketInfo } from "@pages/finance/pocket/pocket_page";
import { DashboardPage } from "@pages/home/dashboard_page";
import { HomePage } from "@pages/home/home_page";
import { ProfilePage } from "@pages/home/profile_page";
import { SuggestionFormPage } from "@pages/home/suggestion_form_page";
import { MadingDetailPage } from "@pages/school/mading/mading_detail_page";
import { MadingListPage } from "@pages/school/mading/mading_list_page";
import { MadingPage } from "@pages/school/mading/mading_page";
import { SettingPage } from "@pages/setting/setting_page";
import { SettingUpdateAccountPage } from "@pages/setting/setting_update_account_page";
import { SubmenuGradesPage } from "@pages/submenu/submenu_grades_page";
import { SubmenuParentingPage } from "@pages/submenu/submenu_parenting_page";
import { SubmenuPage } from "@pages/submenu/submenu_page";
import { SubmenuPaymentPage } from "@pages/submenu/submenu_payment_page";
import { SubmenuTahfidzPage } from "@pages/submenu/submenu_tahfidz_page";
import { createBrowserRouter } from "react-router-dom";
import { SchoolPage } from "@pages/school/school_page";
import { PermitPage } from "@pages/school/permit/permit_page";
import { BiographPage } from "@pages/school/bio/biograph_page";
import { PermitDetailPage } from "@pages/school/permit/permit_detail_page";
import { HealthDataPage } from "@pages/school/health/health_data_page";
import { HealthDetailPage } from "@pages/school/health/health_detail";
import { AbsenceDataPage } from "@pages/school/absence/absence_data_page";
import { AbsenceDetailPage } from "@pages/school/absence/absence_detail_page";
import { EkskulAbsenceDataPage } from "@pages/school/absence/ekskul_absence_data_page";
import { ViolationDataPage } from "@pages/school/violation/violation_data_page";
import { ViolationDetailPage } from "@pages/school/violation/violation_detail_page";
import { AchievementDataPage } from "@pages/school/achievement/achievement_data_page";
import { AchievementDetailPage } from "@pages/school/achievement/achievement_detail_page";
import { TahfidzDataPage } from "@pages/school/tahfidz/tahfidz_data_page";
import { TahfidzDetailPage } from "@pages/school/tahfidz/tahfidz_detail_page";
import { VaDataPage } from "@pages/finance/va/va_data_page";
import { VaDetailPage } from "@pages/finance/va/va_detail_page";
import { DebtPaymentPage } from "@pages/finance/debt/debt_payment_page";
import { SubmenuFinancePage } from "@pages/submenu/submenu_finance_page";
import { CheckingAccDataPage } from "@pages/finance/checking-acc/checking_acc_data_page";
import { MonthlyBillPage } from "@pages/finance/bill/monthly_bill_page";
import { NonMonthlyBillPage } from "@pages/finance/bill/non_monthly_bill_page";
import { SubmenuPermitPage } from "@pages/submenu/submenu_permit_page";
import { PermitDataPage } from "@pages/school/permit/permit_data_page";
import { SettingChangePasswordPage } from "@pages/setting/setting_change_password_page";
import { SubmenuRaporPage } from "@pages/submenu/submenu_rapor_page";
import { ReportCardDailyPage } from "@pages/school/report-card/daily/report_card_daily_page";
import { ReportCardFinalExamPage } from "@pages/school/report-card/final-exam/report_card_final_exam_page";
import { SulukDataPage } from "@pages/school/report-card/suluk/suluk_data_page";
import { FinalReportCardPage } from "@pages/school/report-card/final-report-card/final_report_card_page";
import { FinalReportCardMTWPage } from "@pages/school/report-card/final-report-card/final_report_card_mtw_page";
import { FinalReportCardMAPage } from "@pages/school/report-card/final-report-card/final_report_card_ma_page";
import { DebtBillPage } from "@pages/finance/bill/debt_bill_page";
import { RequestVaPage } from "@pages/finance/va/request_va_page";
import NotFoundPage from "@pages/error/not_found_page";
import { EyeHealthDataPage } from "@pages/school/health/eye_health_data_page";
import { EyeHealthDetailPage } from "@pages/school/health/eye_health_detail_page";
import { TahfidzRekapDataPage } from "@pages/school/tahfidz/tahfidz_rekap_data_page";
import { TahfidzRekapDetailPage } from "@pages/school/tahfidz/tahfidz_rekap_detail_page";
import { TahfidzAbsenceDataPage } from "@pages/school/tahfidz/tahfidz_absence_data_page";

export const linkPage = {
  // AUTH
  AUTH_LOGIN: "/auth/login",

  // HOME
  HOME_DASHBOARD: "/home/dashboard",

  HOME_SUGGESTION_FORM: "/home/suggestion-form",
  HOME_PROFILE: "/home/profile",

  // SCHOOL
  INFO_BIOGRAPH: "/school/biograph",
  PERMIT_PAGE: "/school/request-permit",
  PERMIT_DATA_PAGE: "/school/data-permit",
  PERMIT_DETAIL_PAGE: "/school/permit-detail",
  HEALTH_PAGE: "/school/health",
  HEALTH_DETAIL_PAGE: "/school/health-detail",
  EYE_HEALTH_PAGE: "/school/eye-health",
  EYE_HEALTH_DETAIL_PAGE: "/school/eye-health-detail",
  ABSENCE_PAGE: "/school/absence",
  ABSENCE_DETAIL_PAGE: "/school/absence-detail",
  EKSKUL_ABSENCE_PAGE: "/school/ekskul-absence",
  VIOLATION_PAGE: "/school/violation",
  VIOLATION_DETAIL_PAGE: "/school/violation-detail",
  ACHIEVEMENT_PAGE: "/school/achievement",
  ACHIEVEMENT_DETAIL_PAGE: "/school/achievement-detail",
  TAHFIDZ_DETAIL_PAGE: "/school/tahfidz-detail",
  TAHFIDZ_REKAP_DETAIL_PAGE: "/school/tahfidz-rekap-detail",
  TAHFIDZ_ABSENCE_PAGE: "/school/tahfidz-absence",
  DAILY_REPORT_CARD: "/school/daily-report-card",
  FINAL_EXAM_REPORT_CARD: "/school/final-exam-report-card",
  FINAL_REPORT_CARD: "/school/final-report-card",
  FINAL_REPORT_CARD_MTW: "/school/final-report-card-mtw",
  FINAL_REPORT_CARD_MA: "/school/final-report-card-ma",
  SULUK_PAGE: "/school/data-suluk",

  // OTHER MENU
  MENU_PAYMENT: "/other-menu/payment",
  MENU_ACADEMIC: "/other-menu/academic",
  MENU_TAHFIDZ: "/other-menu/tahfidz",
  MENU_FINANCE: "/other-menu/finance",
  MENU_DORMITORY: "/other-menu/dormitory",
  MENU_PERMIT: "/other-menu/permit",
  MENU_RAPOR: "/other-menu/report-card",

  // SETTING
  SETTING_UPDATE_ACCOUNT: "/setting/update-account",
  SETTING_CHANGE_PASSWORD: "/setting/change-password",

  // FINANCE
  FINANCE_BILLING_INFO: "/finance/billing-info",
  FINANCE_REQUEST_VA: "/finance/:type/request-va",
  FINANCE_POCKET: "/finance/pocket",
  VA_DATA_PAGE: "/finance/data-va",
  VA_DETAIL_PAGE: "/finance/data-va-detail",
  // DEBT_PAYMENT_PAGE: "/finance/debt",
  CHECKING_ACC_PAGE: "/finance/checking-acc",
  MONTHLY_BILL_PAGE: "/finance/monthly-bill",
  NON_MONTHLY_BILL_PAGE: "/finance/non-monthly-bill",
  DEBT_BILL_PAGE: "/finance/debt-bill",

  // MADING
  MADING_DETAIL: "/mading/detail",
};

export const publicRoute = ["/auth/login"];

export const routerRegister = createBrowserRouter([
  {
    path: "/",
    element: <BasePage />,
    errorElement: <NotFoundPage />,
    children: [
      // auth
      {
        path: "auth",
        element: <AuthPage />,
        children: [
          {
            index: true,
            path: "login",
            element: <LoginPage />,
          },
        ],
      },
      // home
      {
        path: "home",
        element: <HomePage />,
        children: [
          {
            index: true,
            path: "dashboard",
            element: <DashboardPage />,
          },

          {
            path: "suggestion-form",
            element: <SuggestionFormPage />,
          },
          {
            path: "profile",
            element: <ProfilePage />,
          },
        ],
      },
      // school
      {
        path: "school",
        element: <SchoolPage />,
        children: [
          {
            index: true,
            path: "biograph",
            element: <BiographPage />,
          },
          {
            path: "request-permit",
            element: <PermitPage />,
          },
          {
            path: "data-permit",
            element: <PermitDataPage />,
          },
          {
            path: "permit-detail",
            element: <PermitDetailPage />,
          },
          {
            path: "health",
            element: <HealthDataPage />,
          },
          {
            path: "health-detail",
            element: <HealthDetailPage />,
          },
          {
            path: "eye-health",
            element: <EyeHealthDataPage />,
          },
          {
            path: "eye-health-detail",
            element: <EyeHealthDetailPage />,
          },
          {
            path: "absence",
            element: <AbsenceDataPage />,
          },
          {
            path: "absence-detail",
            element: <AbsenceDetailPage />,
          },
          {
            path: "ekskul-absence",
            element: <EkskulAbsenceDataPage />,
          },
          {
            path: "violation",
            element: <ViolationDataPage />,
          },
          {
            path: "violation-detail",
            element: <ViolationDetailPage />,
          },
          {
            path: "achievement",
            element: <AchievementDataPage />,
          },
          {
            path: "achievement-detail",
            element: <AchievementDetailPage />,
          },
          {
            path: "tahfidz",
            element: <TahfidzDataPage />,
          },
          {
            path: "tahfidz-detail",
            element: <TahfidzDetailPage />,
          },
          {
            path: "tahfidz-rekap",
            element: <TahfidzRekapDataPage />,
          },
          {
            path: "tahfidz-rekap-detail",
            element: <TahfidzRekapDetailPage />,
          },
          {
            path: "tahfidz-absence",
            element: <TahfidzAbsenceDataPage />,
          },
          {
            path: "daily-report-card",
            element: <ReportCardDailyPage />,
          },
          {
            path: "final-exam-report-card",
            element: <ReportCardFinalExamPage />,
          },
          {
            path: "data-suluk",
            element: <SulukDataPage />,
          },
          {
            path: "final-report-card",
            element: <FinalReportCardPage />,
          },
          {
            path: "final-report-card-mtw",
            element: <FinalReportCardMTWPage />,
          },
          {
            path: "final-report-card-ma",
            element: <FinalReportCardMAPage />,
          },
        ],
      },
      // other menu
      {
        path: "other-menu",
        element: <SubmenuPage />,
        children: [
          {
            index: true,
            path: "payment",
            element: <SubmenuPaymentPage />,
          },
          {
            path: "academic",
            element: <SubmenuGradesPage />,
          },
          {
            path: "tahfidz",
            element: <SubmenuTahfidzPage />,
          },
          {
            path: "finance",
            element: <SubmenuFinancePage />,
          },
          {
            path: "parenting",
            element: <SubmenuParentingPage />,
          },
          {
            path: "permit",
            element: <SubmenuPermitPage />,
          },
          {
            path: "report-card",
            element: <SubmenuRaporPage />,
          },
        ],
      },
      // setting
      {
        path: "setting",
        element: <SettingPage />,
        children: [
          {
            index: true,
            path: "update-account",
            element: <SettingUpdateAccountPage />,
          },
          {
            path: "change-password",
            element: <SettingChangePasswordPage />,
          },
        ],
      },
      // finance
      {
        path: "finance",
        element: <FinancePage />,
        children: [
          {
            index: true,
            path: ":type/request-va",
            element: <RequestVaPage />,
          },
          {
            path: "pocket",
            element: <PocketInfo />,
          },
          {
            path: "data-va",
            element: <VaDataPage />,
          },
          {
            path: "data-va-detail",
            element: <VaDetailPage />,
          },
          {
            path: "debt",
            element: <DebtPaymentPage />,
          },
          {
            path: "checking-acc",
            element: <CheckingAccDataPage />,
          },
          {
            path: "monthly-bill",
            element: <MonthlyBillPage />,
          },
          {
            path: "non-monthly-bill",
            element: <NonMonthlyBillPage />,
          },
          {
            path: "debt-bill",
            element: <DebtBillPage />,
          },
        ],
      },
      // mading
      {
        path: "mading",
        element: <MadingPage />,
        children: [
          {
            index: true,
            path: "list",
            element: <MadingListPage />,
          },
          {
            path: "detail",
            element: <MadingDetailPage />,
          },
        ],
      },
    ],
  },
]);
